/**
 * Created by Timur on 21.08.2026
 */

const Merge2MissionUnitsLibraryWindow = Prefab.createWindow((mission) => Merge2MissionHelper.getBundleName(mission.logic.period), "merge2mission_unitslibrary_window_prefab_json");
